import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';
import ContentMenuCard from "../ContentMenuCard";
import LoadingButton from "../../../Loading/LoadingButton";

import contentNewfolder from "../../../contentImgs/new-folder.png";
import Snackbar from "../../../../Snackbar";
import { createNewFolder } from "../../../../store/actions/CreateContent/FolderAPI/FolderAPIs";
import Loading from "../../../Loading/Loading";
const CreateFolderPopup =({menuOrder,sendBackFolder,changeItemTitle,folderItem,setopenAppDesignPopUp})=>{

     const dispatch = useDispatch();
     
        const [snackbarVisible, setSnackbarVisible] = useState(false);
        const [snackbarColor, setSnackbarColor] = useState("#958FDA");
        const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
      
      const showSnackbar = () => {
        setSnackbarVisible(true);
      };
     
      const hideSnackbar = () => {
        setSnackbarVisible(false);
      };


      const [folderName ,setFolderName] =useState(folderItem?.Name?folderItem?.Name:"")
      const [folderID ,setFolderID] =useState(folderItem?.ID?folderItem?.ID:"");
      const [folderMenuOrder ,setFolderMenuOrder] =useState(folderItem?.menuOrder?folderItem?.menuOrder:menuOrder);
      const [showAddFolderEdit ,setShowAddFolderEdit] =useState(folderItem?.ID?true:false)
       const [showAddFolderDetails ,setShowAddFolderDetails] =useState(folderItem?.ID?true:false)
       
     const [FolderLook ,setFolderLook] =useState("")
           
           
            const [loader , setLoader] =useState({status:false});
      
       const [animate, setAnimate] = useState(false);
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        



      
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     const appId = useSelector((state)=>state?.app?.app?.ID);
          
       useEffect(() => {
         // Trigger the animation after a delay (e.g., 500ms)
         const timer = setTimeout(() => {
          setAnimate(true);  
        }, 100);
      
         return () => clearTimeout(timer); // Cleanup on unmount
       }, []);
      useEffect(()=>{
        // setCourseTitleData();
      },[])
      
      
const handleCreateFolder=(e)=>{



setLoader({status:true});
console.log({Name:folderName,
    token:AppToken,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:"",
    currentToken:currentToken?currentToken:"",appToken:AppToken,
    editType:'',postId:folderID,menuOrder:folderMenuOrder})
  const apiData = dispatch(createNewFolder({Name:folderName,
    token:AppToken,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:"",
    currentToken:currentToken?currentToken:"",appToken:AppToken,
    editType:'',postId:folderID,menuOrder:folderMenuOrder,appId:appId}));
  /* get response as Promise   */
  apiData.then(response => {
    if(response){

      console.log(response)
      if(response?.folder){
    setResponseMessage(response?.message);
    setSnackbarColor("rgba(144, 202, 249,1)");
  
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
  sendBackFolder(response?.folder);
  // console.log(response?.folder)
  setFolderName(response?.folder?.Name);
  setFolderID(response?.folder?.ID);
  setFolderMenuOrder(response?.folder?.menuOrder)
  setShowAddFolderDetails(true)
  setShowAddFolderEdit(true)
},1000)
   }else{
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
    // dispatch({
    //   type: "UPDATE_APP_TOKEN",
      
    //   payload:response?.course?.AppToken
    // });  
  //  console.log(response?.course);
 
   // 
   if(response?.logout){
    // pop up response?.logoutInfo
    //console.log(response?.logoutInfo)

    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }
/* resetting Login input Fields */

    }else{
      setResponseMessage("Something Went Wrong...");
      
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
 
  }
  
     
const handleUpdateFolder=(val)=>{
  let editType="";
if(val=="Name"){
 editType="Name";
}
  setLoader({status:true});

  // console.log({Name:folderName,
  //   token:AppToken,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:null,
  //   currentToken:currentToken?currentToken:null,appToken:AppToken,
  //   editType:editType,postId:folderID,menuOrder:folderMenuOrder})
      const apiData = dispatch(createNewFolder({Name:folderName,
      token:token,courseId:postIdCourse ,postParent:postIdCourse ,userEmail:user_email?user_email:null,
      currentToken:currentToken?currentToken:null,appToken:AppToken,
      editType:editType,postId:folderID,menuOrder:folderMenuOrder,appId:appId}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){

        // console.log(response)
        if(response?.folder){
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
changeItemTitle(response?.folder?.ID,response?.folder?.Name);
    setSnackbarVisible(false);
    setFolderName(response?.folder?.Name);
    setFolderID(response?.folder?.ID);
    setShowAddFolderDetails(true)
    setShowAddFolderEdit(true)

  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
      // dispatch({
      //   type: "UPDATE_APP_TOKEN",
        
      //   payload:response?.course?.AppToken
      // });  
    //  console.log(response?.course);
   
     // 
     if(response?.logout){
      // pop up response?.logoutInfo
      //console.log(response?.logoutInfo)
  
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }



    return (<>
    
   {/* {<Loading  Load={loader?.status}/>} */}
     {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
    {FolderLook==""?<div className="" style={{alignContent:"center",textAlign:"center",marginTop:"0px",
     
     transition: 'transform 2s ease, opacity 1s ease',
   }}> <div className="userInfoLinerName"> <h2>Add Folder Name</h2></div>
      <div className="createFolderImgTop"> 
       <div style={{height:"120px",width:"120px",borderRadius:"50%",background:"#ffffff"}}>
      <img     src={contentNewfolder} 
       alt="selected Img"
  style={{cursor:"pointer",width:"60px",margin:"30px",marginTop:"30px"
   
  }}/> </div> </div> 
     <div className="createFolderImgTop">
     
<textarea onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} className="createContentTextbox"  style= {{fontSize:"24px",width:"90%"}} placeholder="Add Name Of A Folder" type="text"
 rows={2} name="courseTitle" value={folderName} onChange={(e)=>setFolderName(e.target.value)} />
   </div> 

   {showAddFolderDetails?<>
   <div className="userInfoLinerName"> <h3>Add Folder Details</h3></div>
    <div className="createFolderImgTop"> <div className="gridForFolderOptionContents" style={{marginBottom:"40px",width:"95%"}}> 
   <ContentMenuCard  icon={4} title ="+ Add Description" onClickPopup={()=>{setFolderLook("description")}}  />
   <ContentMenuCard  icon={5} title ="+ Add Highlights" onClickPopup={()=>{setFolderLook("highlight")}}  />
   {/* <ContentMenuCard  icon={7} title ="+ Add FAQs" onClickPopup={()=>{setFolderLook("faq")}}  /> */}
   </div>  </div>  
   </>:""}
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div  >   </div>
 
   
   <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setopenAppDesignPopUp()}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
    id="signupBtn"> Cancel </button>
{showAddFolderEdit?
<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleUpdateFolder("Name")}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Update"} </button>:
<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateFolder()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Click To Create"} </button>}
 </div> </div>
 
 :FolderLook=="description"?
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
 <div className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           <div className="userInfoLinerName"> <h2>Add Description</h2></div></div>
          
   
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div></div>

<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save Info"} </button>
 </div></div>


   :FolderLook=="highlight"?
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
<div className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           <div className="userInfoLinerName"> <h2>Add Highlight</h2></div></div>
            
   
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div></div><button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
    id="signupBtn"> Back </button>

<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save Info"} </button>
 </div></div>
 
   :FolderLook=="faq"?
 <div className="" style={{alignContent:"center",textAlign:"center",marginTop:"10px",transition: 'transform 2s ease, opacity 1s ease',}}>  
 <div className="userInfoLinerInnBack"><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave} style={{cursor:"pointer",left:"30px",background:"#f1f1f1"}} 
           onClick={()=>{setFolderLook("")}}   className="userInfoLinerButtonBack">Back</div>
           <div className="userInfoLinerName"> <h2>Add FAQs</h2></div></div>
           
   
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div></div><button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setFolderLook("")}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
    id="signupBtn"> Back </button>

<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save Info"} </button>
 </div></div>:""}
       </>)
}
export default CreateFolderPopup;

